const ALL_CONTEXTS = "__all__";

export function hasActiveActivitiesFilters({ typeFilter, contextFilter }) {
  return Boolean(typeFilter) || contextFilter !== ALL_CONTEXTS;
}

export function getActivitiesEmptyText({ typeFilter, contextFilter }) {
  return hasActiveActivitiesFilters({ typeFilter, contextFilter })
    ? "Keine Aktivitäten für die aktuellen Filter gefunden."
    : "Keine Aktivitäten vorhanden.";
}

